var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bread-crumb',{attrs:{"navigationArray":_vm.navigationLink}}),_c('section',{staticClass:"structure-main"},[_c('div',{staticClass:"white-container"},[_c('h5',[_vm._v(_vm._s(_vm.detail.title))]),_c('div',{staticClass:"ckEditor-html",domProps:{"innerHTML":_vm._s(_vm.detail.text)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }